import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e0e902b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-project com-search" }
const _hoisted_2 = { class: "choice-content" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      placeholder: "请输入搜索关键词",
      modelValue: _ctx.searchVal,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchVal) = $event)),
        _ctx.onSearch
      ],
      onCancel: _ctx.onCancel
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onCancel"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "choice-item",
          key: index,
          onClick: ($event: any) => (_ctx.goCheckSpace(item))
        }, _toDisplayString(item.localName), 9, _hoisted_3))
      }), 128))
    ])
  ]))
}